module.exports = __webpack_public_path__ + "static/media/state1.0c1e2454.svg";